const locale = {
  disabled: ' 被禁用'
};
export default locale;